import { Interp, css } from '../../lib/render.jsx';

export default function ReqSent({ v }) {
  if (!v.showReqSent) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "98", "padding": "20px" }} onClick={v.closeReqSent}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(400px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px", "alignItems": "center", "textAlign": "center", "boxSizing": "border-box" }}>
          <span style={{ "fontSize": "38px", "lineHeight": "1" }}>
            📨
          </span>
          <div style={{ "fontSize": "21px", "fontWeight": "700", "lineHeight": "1.2" }}>
            Verzoekje verstuurd!
          </div>
          <div style={{ "fontSize": "14px", "fontWeight": "600", "color": "var(--tekst-2)", "lineHeight": "1.4" }}>
            <Interp v={v.reqSentLine} />
          </div>
          <button onClick={v.closeReqSent} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Top
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
